export default __webpack_public_path__ + "static/styles-dropdown-custom-8a58de72373f3542babe9aaf4314644c8c4c202b683155925c0b1dc665036646.png";